// extracted by mini-css-extract-plugin
export default {"rplUpsell":"RplUpsell-module_rplUpsell-i4syx","rplIcon":"RplUpsell-module_rplIcon-iIti7"};